import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

export interface DialogLocalStorage {
	doNotShowAgain: string[];
}

export const buildEmptyIgnoredDialogs = (): DialogLocalStorage => {
	return { doNotShowAgain: [] };
};

@Injectable({ providedIn: 'root' })
export class IgnoreDialogService {
	private readonly IGNOREDIALOGS_LOCAL_STORAGE_KEY = 'ignore_confirmation_dialogs';

	private _ignoredDialogs$ = new ReplaySubject<DialogLocalStorage>(1);
	public ignoredDialogs$ = this._ignoredDialogs$.asObservable();

	constructor() {
		this._ignoredDialogs$.next(this.readIgnoredDialogs());
	}

	public clearIgnoredDialogs(): void {
		this.writeIgnoredDialogs(buildEmptyIgnoredDialogs());
	}

	public setIgnoredDialog(doNotShowDialog: boolean, id?: string): void {
		if (id) {
			const ignoredDialogs = this.readIgnoredDialogs();
			if (doNotShowDialog && !ignoredDialogs.doNotShowAgain.includes(id)) {
				ignoredDialogs.doNotShowAgain.push(id);
			}
			this.writeIgnoredDialogs(ignoredDialogs);
		}
	}

	public isDialogIgnored(id: string): boolean {
		const ignoredDialogs = this.readIgnoredDialogs();
		return ignoredDialogs.doNotShowAgain.indexOf(id) > -1;
	}

	private readIgnoredDialogs(): DialogLocalStorage {
		const ignoredDialogs = localStorage.getItem(this.IGNOREDIALOGS_LOCAL_STORAGE_KEY);
		if (!ignoredDialogs) {
			return buildEmptyIgnoredDialogs();
		}
		return JSON.parse(ignoredDialogs);
	}

	private writeIgnoredDialogs(ignoredDialogs: DialogLocalStorage): void {
		localStorage.setItem(this.IGNOREDIALOGS_LOCAL_STORAGE_KEY, JSON.stringify(ignoredDialogs));
		this._ignoredDialogs$.next(ignoredDialogs);
	}
}
